import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { ESignatureEnvelopeStatusEnum } from '../enums/e-signature-envelope-status.enum';

import { ESignatureRecipientDto } from './e-signature-recipient.dto';

/**
 * E-signature envelope row exposed on rental agreement and API responses
 */
export class ESignatureEnvelopeRecordDto {
	id!: number;
	externalEnvelopeId!: string;
	externalDocumentId!: string;
	sourceSubject!: AppSubjectEnum;
	sourceId!: number;
	status!: ESignatureEnvelopeStatusEnum;
	recipient?: ESignatureRecipientDto;
	sender?: ESignatureRecipientDto;
	recipientEmail?: string;
	senderEmail?: string;
	sentAt?: Date;
	completedAt?: Date;
	expiresAt?: Date;
}
